import { Select, MenuItem, Stack, useTheme } from "@mui/material";
import { CohortMemberStatus } from "generated-graphql/graphql";
import pluralize from "pluralize";
import { useForm } from "react-hook-form";

import { ConfirmDialog } from "./ConfirmDialog";

type ChangeStatusFormDialogProps = {
  cohortMemberIds: string[];
  open: boolean;
  onClose: () => void;
  onSubmit: (formState: ChangeStatusFormState) => Promise<void>;
  loading: boolean;
};

export type ChangeStatusFormState = {
  status: CohortMemberStatus;
};

export function ChangeCohortMemberStatusFormDialog({
  cohortMemberIds,
  open,
  onClose,
  onSubmit,
  loading,
}: ChangeStatusFormDialogProps) {
  const theme = useTheme();

  const form = useForm<ChangeStatusFormState>({
    defaultValues: {
      status: CohortMemberStatus.Unknown,
    },
  });

  const status = form.watch("status");

  const updateStatus = (status: CohortMemberStatus) => {
    form.setValue("status", status);
  };

  const handleClose = () => {
    onClose();
    form.reset();
  };

  return (
    <ConfirmDialog
      open={open}
      onClose={handleClose}
      header={`Change Status for ${cohortMemberIds.length} ${pluralize(
        "Cohort Member",
        cohortMemberIds.length
      )}`}
      confirmText="Yes, I'm sure"
      cancelText="No, cancel"
      onConfirm={() => {
        onSubmit(form.getValues());
      }}
      info={
        <Stack gap={theme.spacing(2)}>
          <Select
            value={status}
            onChange={(e) => updateStatus(e.target.value as CohortMemberStatus)}
          >
            {Object.values(CohortMemberStatus).map((s) => (
              <MenuItem key={s} value={s}>
                {s.replace(/_/g, " ")}
              </MenuItem>
            ))}
          </Select>
        </Stack>
      }
      loading={loading}
      disableConfirm={!cohortMemberIds.length || !status}
    />
  );
}
